module.exports = "<div tabindex=\"-1\" class=\"gw-modal gw-fade {{ windowClass }}\" ng-class=\"{in: animate}\"\n     ng-style=\"{'z-index': 20020 + index*10}\" ng-transclude></div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/modal/templates/modal-window-template.html
// module id = 475
// module chunks = 0